module.exports = __webpack_public_path__ + "img/oculus_before_after_1.aa9049ee.png";